export default "__VITE_ASSET__9f893e70__"